import ErrorPage from "@/components/error/ErrorPage";

const NotFoundPage: React.FC = () => {
  return (
    <ErrorPage
      statusCode={404}
      title='페이지를 찾을 수 없습니다'
      message='요청하신 페이지가 존재하지 않거나 이동되었습니다.'
    />
  );
};

export default NotFoundPage;
